import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import ModalLayout from '../../../Modal/ModalLayout';
import s from './VerticalLayout.scss';
const VerticalLayout = (_param)=>{
    var { image, title, message, className, footerButtons, footerExtras } = _param, rest = _object_without_properties(_param, [
        "image",
        "title",
        "message",
        "className",
        "footerButtons",
        "footerExtras"
    ]);
    return /*#__PURE__*/ React.createElement(ModalLayout, _object_spread({
        className: c(s['root'], className),
        footer: /*#__PURE__*/ React.createElement("div", {
            className: s['footer']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['footer-buttons']
        }, footerButtons), /*#__PURE__*/ React.createElement("div", {
            className: s['footer-extras']
        }, footerExtras)),
        content: /*#__PURE__*/ React.createElement("div", {
            className: s['content-root']
        }, image && /*#__PURE__*/ React.createElement("div", {
            className: s['image']
        }, image), /*#__PURE__*/ React.createElement("div", {
            className: s['title']
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: s['message']
        }, message))
    }, rest));
};
VerticalLayout.displayName = 'VerticalLayout';
export default VerticalLayout;

//# sourceMappingURL=VerticalLayout.js.map